import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import { fetchNavbarAndFooter } from "lib/fetchers/common";

import SubscribeView from "content-ui/subscribe";
import {
  fetchSubscribePageData,
  type SubscribePageProps,
} from "content-ui/subscribe/fetcher";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";
import PaymentForm from "components/zephr/PaymentForm";

export async function getStaticProps({ preview = false }) {
  const [menuItems, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchSubscribePageData({ preview }),
  ]);

  return {
    props: {
      dato: dato,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
    // we will attempt to re-generate the page:
    // - when a request comes in
    // - at most once every minute
    revalidate: 60,
  };
}

type PageProps = {
  dato: SubscribePageProps;
};

const SubscribePage = (props: PageProps) => {
  const { seo } = props.dato;

  return (
    <>
      <Head>
        {generateNextSeo({
          canonical: buildCanonicalUrl("/subscribe"),
          openGraph: {
            title: seo.title,
            description: seo.description,
            images: [{ url: seo.image ? seo.image.url : "" }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />

      <ErrorBoundary>
        <PaymentForm />
        <SubscribeView data={props.dato} />
      </ErrorBoundary>

      <Footer />
    </>
  );
};

export default SubscribePage;
